import { render } from "./AdminSysOverviewTab.vue?vue&type=template&id=ca7df57a&ts=true"
import script from "./AdminSysOverviewTab.vue?vue&type=script&lang=ts"
export * from "./AdminSysOverviewTab.vue?vue&type=script&lang=ts"

import "./AdminSysOverviewTab.vue?vue&type=style&index=0&id=ca7df57a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__